export default __webpack_public_path__ + "static/media/touch-cursor-pan.fdb623a5.svg";